import * as React from 'react';
import {Map} from 'immutable';
import {connect} from 'react-redux';
import {closeDynamicElement, removeDynamicElement} from '../../redux/modules/panel/panel';
import {StoreState} from '../../../App/initialStore';

const DynamicElements: React.FunctionComponent<{
  dynamicElements: Map<string, any>;
  closeDynamicElement: typeof closeDynamicElement;
  removeDynamicElement: typeof removeDynamicElement;
}> = ({dynamicElements, closeDynamicElement, removeDynamicElement}) => {
  return dynamicElements
    .map(({elementType, props}, index) => {
      return React.createElement(elementType, {
        key: index,
        ...props,
        onClose: () => closeDynamicElement(index),
        onExited: () => removeDynamicElement(index),
      });
    })
    .toArray() as any;
};

export default connect(
  (state: StoreState) => ({
    dynamicElements: state.panel.dynamicElements || Map(),
  }),
  {closeDynamicElement, removeDynamicElement}
)(DynamicElements);
